'use strict';
//Jquery
//import $ from "jquery";
// jquery importuojamas globaliai webpack

//Bootstrap
//import Bootstrap from 'bootstrap';
//import "bootstrap/dist/css/bootstrap.css";

//Slick slider
import SlickSlider from 'slick-slider';
import "slick-slider/slick/slick.css";

//moment
import moment from 'moment';
moment.locale('lt');

//pikaday
import Pikaday from 'pikaday';
import "pikaday/css/pikaday.css";

//tooltipster
import Tooltipster from 'tooltipster';
import "tooltipster/dist/css/tooltipster.bundle.css";

import { Fancybox } from "@fancyapps/fancybox";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";

import select2 from 'select2';
import "select2/dist/css/select2.css";

import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_lt';

import '../lib/lightgallery/js/lightgallery.ew4.js';

import '../lib/jquery-nicefileinput/jquery.nicefileinput.js';
import '../lib/javascript-equal-height-responsive-rows/grids.js';

import 'jquery.highlight-bartaz';

import { globalJsTranslations } from '../services/globaljstranslations.js';
import { hashController } from '../controllers/hashcontroller.js';

window.$ = $;

$(document).ready(function () {
	if (!$("#popup_window").length) { // init if not in dialog view
		select2init();
//		mobile_sidebar();
		fancybox();
		validate();
		slick_carousel();
		gallery_hash();
		youtube_hash();
		fixed_header();
		print_v();
		highlight_search_results();
		init_questions_toggler_hash();
		catalog_gallery();
		file_input();
		iframe_adaptability();
		reportbug_form();
		show_more();
		postformwidget_validate();
		init_contacts();
		tooltipster();
        tooltipPlain();

		sidebar_menu();
		scroll_top();

		set_widgetcalendar_data();
		showDayEvent();
		EventCalendar();
		toggle_items();
		loadTitlepageCalendar();
		callSearchWidget();
		toggleLang();
		pikaday();
		mapFill();
		user_control();
	}

	$('.footer_email_input').on('input', function() {
		const emailInput = $(this);
		const spanElement = $('.icon-subscr_button');

		console.log(spanElement)

		// Regex for validating email
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (emailRegex.test(emailInput.val())) {
			spanElement.addClass('valid-email');
		} else {
			spanElement.removeClass('valid-email');
		}
	});
});

$(window).on('load', function () {
	$('.equalheight').responsiveEqualHeightGrid();
	if ($(window).width() < 768) {
		mobile_overflow_tables();
	}
	addAriaLabelToMobileMenu();
});

function select2init() {
	$("select").select2({
		"minimumResultsForSearch": -1
	});

	// use this class if placeholder is needed.
	// Translation added as data attribute: <select data-placeholder="{'choise_value'|t}">
	// Also, first option in select element has to be empty: <option value=""></option>
	$("select.select2_with_dynamic_placeholder").select2({
		"minimumResultsForSearch": -1,
		placeholder: function () {
			$(this).data('placeholder');
		}
	});
}

function pikaday() {
	const datePickerElements = document.querySelectorAll('.datepicker');

	datePickerElements.forEach(datePickerElement => {
		const today = new Date();
		// const formattedDate = moment(today).format('YYYY-MM-DD');

		// datePickerElement.value = formattedDate;

		datePickerElement.parentElement.style.position = 'relative';
		datePickerElement.style.background = 'transparent';
		datePickerElement.style.zIndex = '20';

		const calendarIcon = document.createElement('span');
		calendarIcon.classList.add('icon', 'icon-calendar');
		calendarIcon.style.position = 'absolute';
		calendarIcon.style.top = '55%';
		calendarIcon.style.transform = 'translateY(-50%)';
		calendarIcon.style.left = '105px';

		datePickerElement.parentNode.insertBefore(calendarIcon, datePickerElement.nextSibling);

		new Pikaday({
			field: datePickerElement,
			format: 'YYYY-MM-DD',
			firstDay: 1,
			autocomplete: false,
			showDaysInNextAndPreviousMonths: false,
			toString(date) {
				return moment(date).format('YYYY-MM-DD');
			},
			parse(dateString) {
				return moment(dateString, 'YYYY-MM-DD').toDate();
			},
			i18n: {
				previousMonth: '',
				nextMonth: '',
				months: moment.localeData().months(),
				weekdays: moment.localeData().weekdays(),
				weekdaysShort: moment.localeData().weekdaysShort()
			},
		});
	});
}


function slick_carousel() {
	// Slick carousel docs:
	//http://kenwheeler.github.io/slick/

	if ($("#title_slides").length) {
		$('#title_slides').slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			rows: 0
		});

		$('#title_slides').on('afterChange', function (event, slick, currentSlide, nextSlide) {
			//console.log(slick);
		});
	}

	if ($(".promoblock_slider").length) {
		$('.promoblock_slider').slick({
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 6,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 420,
					settings: {
						slidesToShow: 2,
					}
				}],
			slidesToScroll: 1,
			speed: 200,
			cssEase: 'linear',
			rows: 0,
			autoplay: true,
			autoplaySpeed: 5000,
		});
	}
}

$(document).ready(function(){
	$('.s--slidestext .slider').slick({
		lazyLoad: 'progressive',
		dots: true,
		infinite: true,
		speed: 800,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false
	});
});

if ($(".s--slidesvideos .slider").length) {
	$('.s--slidesvideos .slider').slick({
		lazyLoad: 'progressive',
		dots: false,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
	});
	$(".slider").on("lazyLoaded", function(e, slick, image, imageSource){
		var desktop_image = image.data('desktop');
		var mobile_image = image.data('mobile');
		image.attr('src','data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');

		//set the correct image based on size of screen
		imageSource = desktop_image;
		if($(window).width()<768){
			imageSource = mobile_image;
		}
		image.attr('src',imageSource);
	});
}

$(document).ready(function () {
	const targetHash = "#areasofactivity";
	const offset = 200;

	if (window.location.hash === targetHash) {
		setTimeout(() => {
			const $targetElement = $(targetHash);

			if ($targetElement.length) {
				const offsetPosition = $targetElement.offset().top - offset;

				$("html, body").animate(
					{ scrollTop: offsetPosition },
					600
				);
			}
		}, 100);
	}

	$(`a[href="${targetHash}"]`).on("click", function (e) {
		e.preventDefault();
		const $targetElement = $(targetHash);

		if ($targetElement.length) {
			const offsetPosition = $targetElement.offset().top - offset;

			$("html, body").animate(
				{ scrollTop: offsetPosition },
				600
			);

			history.pushState(null, null, targetHash);
		}
	});
});

function mapFill() {
	var item = $('.seniunijos-home__header__item a');
	var mapItem = $('.seniunijos-home__map svg path');
	var groupItem = $('.seniunijos-home__map svg g.text-group');

	function handleMouseEnter(target, targetItems) {
		var targetId = target.attr('id').replace(/^link_|^area_|^group_/, '');

		targetItems.each(function () {
			const targetObj = $(this);
			var itemId = targetObj.attr('id').replace(/^link_|^area_|^group_/, '');

			if (itemId === targetId) {
				targetObj.addClass('active');
			} else {
				targetObj.removeClass('active');
			}
		});
	}

	function handleMouseLeave(targetItems) {
		targetItems.removeClass('active');
	}

	item.add(mapItem).add(groupItem).mouseenter(function () {
		handleMouseEnter($(this), item.add(mapItem).add(groupItem));
	});

	item.add(mapItem).add(groupItem).mouseleave(function () {
		handleMouseLeave(item.add(mapItem).add(groupItem));
	});
}

function showOnlyOneSearch() {
	if (window.innerWidth > 1024) {
		$('.mobile-search').remove();
	} else {
		$('.desktop-search').remove();
	}
}

function callSearchWidget() {
	showOnlyOneSearch();

	$('#search-widget-call').on('click', function (e) {
		e.stopPropagation();
		$('.search-widget').slideToggle('slow');
		$('.header_container').toggleClass('expanded');

		if ($('.header_container').hasClass('expanded')) {
			$('body').append('<div class="modal-backdrop"></div>').addClass('o-hidden');
		} else {
			$('.modal-backdrop').remove();
			$('body').removeClass('o-hidden');
		}
	});

	$('.close-widget').on('click', function () {
		closeSearchWidget();
	});

	$(document).on('click', function (e) {
		if ($('.header_container').hasClass('expanded') && !$(e.target).closest('.search-widget').length && !$(e.target).is('#search-widget-call')) {
			closeSearchWidget();
		}
	});

	function closeSearchWidget() {
		$('.search-widget').slideUp('slow');
		$('.header_container').removeClass('expanded');
		$('.modal-backdrop').remove();
		$('body').removeClass('o-hidden');
	}
}

function toggleLang() {
	$('.lang-toggle').on('click', function(event) {
		event.preventDefault();
		$(this).parent('.langs').toggleClass('open');
	});

	$(document).on('click', function(event) {
		if (!$(event.target).closest('.langs').length) {
			$('.langs').removeClass('open');
		}
	});
}


function fancybox() {
	// FB3 docs: https://fancyapps.com/fancybox/3/docs
	//  Translations inside libs/localization/

	// News preview
	$("a.news_image").fancybox({
		btnTpl: {
			zoom: false
		}
	});

	// News gallery
	$("a.fancybox_gallery").fancybox({
		thumbs: false,
		transitionEffect: "slide",
		clickContent: false,
		btnTpl: {
			zoom: false
		}
	});

	// From Tinymce
	$("a[rel=fancybox]").fancybox({
		btnTpl: {
			zoom: false
		}
	});
	// From Tinymce
	$("a[rel=fancybox-images]").fancybox({
		btnTpl: {
			zoom: false,
			slideShow: false,
			thumbs: false,
		}
	}).attr('data-fancybox', 'images');

	// Ajax call
	$("a.fancybox_ajax").fancybox({
		type: "ajax",
		touch: false // disable drag cursor
	});

	// Iframe call
	$("a.fancybox_iframe").fancybox({
		type: "iframe",
		touch: false // disable drag cursor
	});
}

function gallery_popup() {
	$('.gallery_popup').on("click", function () {
		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");
		$.ajax({
			url: url,
			type: "GET",
			success: function (data) {
				$(".album_loading").fadeOut("fast");
				var photos = [];
				$.each(data.photos, function (i) {
					var obj = {
						"src": this.img_itemimage,
						"thumb": this.img_itemimage_thumb
					};
					if (this.title) {
						obj.subHtml = '<div class="photo_title">' + this.title + '</div>';
					}
					photos.push(obj);
				});
				$this.lightGallery({
					dynamic: true,
					dynamicEl: photos,
					speed: 300,
					hideBarsDelay: 1000,
					closable: false,
					loop: false,
					download: false,
					enableDrag: false,
					thumbWidth: 112,
					thumbContHeight: 83,
					thumbMargin: 10,
					toogleThumb: false,
					galleryId: $this.data("id")
				});
				$this.on('onAfterOpen.lg', function (event, index, fromTouch, fromThumb) {
					$(".lg").append("<div class='album_title lg-toolbar'><div class='album_title_text'>" + data.title + "</div></div>")
				});
			},
			error: function () {
				$(".album_loading").fadeOut("fast");
				alert('Load error.');
			}
		});


	});
}

function youtube_popup() {
	$('.youtube_popup').on("click", function () {

		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");
		$.ajax({
			url: url,
			type: "GET",
			success: function (data) {
				$(".album_loading").fadeOut("fast");
				var photos = [];
				var obj = {
					"src": data.youtube_share_link,
					"thumb": data.img_itemimage_thumb,
					//"poster":  data.img_itemimage_thumb
				};
				if (data.title) {
					obj.subHtml = '<div class="photo_title">' + data.title + '</div>';
				}
				photos.push(obj);
				$this.lightGallery({
					dynamic: true,
					dynamicEl: photos,
					speed: 300,
					hideBarsDelay: 1000,
					closable: false,
					loop: false,
					download: false,
					enableDrag: false,
					thumbWidth: 112,
					thumbContHeight: 83,
					thumbMargin: 10,
					toogleThumb: false,
					//youtubePlayerParams: {autoplay:0 },
					counter: false,
					videoMaxWidth: '900px',
					addClass: "youtubegallery_popup",
					fullScreen: false
				});
			},
			error: function () {
				$(".album_loading").fadeOut("fast");
				alert('Load error.');
			}
		});


	});
}

function validate() {
	var options = {
		highlight: function (element, errorClass, validClass) {
			if ($(element).closest(".type_item").length) {
				$(element).closest(".type_item").removeClass(validClass).addClass(errorClass);
			}
		},
		unhighlight: function (element, errorClass, validClass) {
			if ($(element).closest(".type_item").length) {
				$(element).closest(".type_item").removeClass(errorClass).addClass(validClass);
			}
		},
		errorPlacement: function (error, element) {
			$(element).closest(".type_item").find('.type_error').append(error);
		},
	}
	if ($("#forms_form").length) {
		$("#forms_form").validate(options);
		$("#forms_form select").change(function () {
			$(this).valid();
		});
		$("#forms_form input[type='file']").change(function () {
			$(this).valid();
		});
	}
	if ($("#letter_form").length) { // Postform
		$("#letter_form").validate(options);
	}
	if ($("#poll_form").length) {
		$("#poll_form").validate(options);
		$("#poll_form select").change(function () {
			$(this).valid();
		});
		$("#poll_form input[type='file']").change(function () {
			$(this).valid();
		});
	}
	if ($("#subscription_form").length) {
		$("#subscription_form").validate(options);
	}
	if ($("#poll_widget").length) {
		$("#poll_widget").validate(options);
	}
	if ($("#sitelogin_widget").length) {
		$("#sitelogin_widget").validate(options);
	}
	if ($("#duk_form").length) {
		$("#duk_form").validate(options);
	}
	if ($(".comment-form").length) {
		$(".comment-form").validate(options);
	}
	if ($("#sitelogin_form").length) {
		$("#sitelogin_form").validate(options);
	}
	if ($("#faq_form").length) {
		$("#faq_form").validate(options);
	}
	if ($("#subscription_form_index").length) {
		$("#subscription_form_index").validate(options);
	}
	if ($("#remind_pass_form").length) {
		$("#remind_pass_form").validate(options);
	}

	if ($('#custom_validate').length) {
		$("#custom_validate").validate(options);
		$("#custom_validate select").change(function () {
			$(this).valid();
		});
		$("#custom_validate input[type='file']").change(function () {
			$(this).valid();
		});
	}
}

/**
 * Alias for hashController
 * @type @exp;hashController
 */
window.hc = hashController;

/**
 * @example hc.register({callback: function(e, h){
 *			console.log(h.get());
 *		}});
 *
 *		hc.set('raudona');
 */

$(document).ready(function () {
	hc.trigger();
});

function galleryWrapper() {
	this.photos = new Array();
	this.album_data;
	this.album_id;
	this.photo_id = '';
	this.dataUrl = '';
	this.isOpen = false;
	this.base_url = location.pathname + '/';
	this.hcb;

	this.gallery_options = {
		dynamic: true,
		speed: 300,
		hideBarsDelay: 2000,
		closable: false,
		loop: true,
		download: false,
		enableDrag: false,
		thumbWidth: 112,
		thumbContHeight: 93,
		thumbMargin: 10,
		showAfterLoad: false,
		toogleThumb: false,
		galleryId: this.album_id
	};

	if (arguments[0] && typeof (arguments[0]) === 'object') {
		$.extend(this.gallery_options, arguments[0]);
	}

	var self = this;

	this.getElement = function () {
		if (!document.getElementById(this.album_id)) {
			$('body').append('<div id="' + this.album_id + '" style="display:none;"></div>');
		}
		return $('#' + this.album_id);
	};

	this.init = function () {
		if (!this.isOpen) {
			$(".album_loading").show();
			$.ajax({
				url: this.dataUrl,
				type: "GET",
				dataType: "json",
				contentType: "application/json",
				success: function (data) {
					self.album_data = data;
					self.setPhotos(data);
					if (self.photos.length > 0) {
						self.initgallery();
						$(".album_loading").fadeOut("fast");
					} else {
						$(".album_loading").fadeOut("fast");
						self.close();
					}
				},
				error: function () {
					$(".album_loading").fadeOut("fast");
					alert('Load error.');
				}
			});
		}
	};

	this.setPhotos = function (data) {
		if (typeof (data.photos) !== 'undefined') {
			for (var i = 0; i < data.photos.length; i++) {
				var obj = {
					src: ($(window).width() > 800 ? data.photos[i].img__original : data.photos[i].img_itemimage)
				};
				if (typeof (data.photos[i].img_itemimage_thumb) !== 'undefined') {
					obj.thumb = data.photos[i].img_itemimage_thumb;
				} else {
					obj.thumb = data.photos[i].img_listimage;
				}
				if (data.photos[i].title) {
					obj.subHtml = '<div class="photo_title">' + data.photos[i].title + '</div>';
				}
				self.photos.push(obj);
			}
		}
	};

	this.initgallery = function () {
		var cont = this.getElement();
		if (this.photo_idx > 0 && this.photos.length > this.photo_idx) {
			this.gallery_options.index = this.photo_idx;
		}
		this.gallery_options.dynamicEl = this.photos;
		this.gallery_options.galleryId = this.album_id;
		$(cont).lightGallery(this.gallery_options);
		this.isOpen = true;
		this.galleryEvents(cont);
	};

	this.galleryEvents = function (cont) {
		$(cont).on('onAfterOpen.lg', function () {
			if ($("#album_title").length) {
				$("#album_title").html(self.album_data.title);
			} else {
				$(".lg").append("<div class='album_title lg-toolbar'><div id='album_title' class='album_title_text'>" + self.album_data.title + "</div></div>");
			}
			if (!$(".gallery_share").length) {
				$(".lg-toolbar.group").append("<div class='gallery_share'><div class='share_icon'></div><div class='share_drop'><div class='share_fb'></div><div class='share_gplus'></div></div></div>");
				//$("<div class='gallery_share'><div class='share_icon'></div><div class='share_drop'><div class='share_fb'></div><div class='share_gplus'></div></div></div>").insertAfter(".lg-fullscreen");

				$(".lg-outer").on("click", function () {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
				});
				$(".share_icon").on("click", function (e) {
					$(this).addClass("active");
					e.stopPropagation();
					$(this).parent().find(".share_drop").slideToggle("fast");
				});

				$(".share_fb").on("click", function (e) {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
					window.open("https://www.facebook.com/sharer/sharer.php?u=" + escape(window.location.href), 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
					return false;
				});
				$(".share_gplus").on("click", function (e) {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
					window.open("https://plus.google.com/share?url=" + escape(window.location.href), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
					return false;
				});
			}
			if (self.photo_idx > 0) {
				$(cont).data('lightGallery').slide(self.photo_idx);
			}
		});
		$(cont).on('onCloseAfter.lg', function () {
			self.hcb.hashObj.clear();
			self.close();
		});
		$(cont).on('onAfterSlide.lg', function (event, index, fromTouch, fromThumb) {
			self.hcb.hashObj.replace('!' + self.album_id + '/photo' + $(cont).data('lightGallery').index);
//			setTimeout(function(){self.ignore(false);}, 50);
		});
	};

	this.route = function (e, hcb) {
		this.hcb = hcb;
		var parts = this.hcb.hashObj.get().replace(/^\!/, '').split('/');
		this.album_id = parts[0];

		this.dataUrl = this.getUrl();

		this.ignore(true);
		if (parts.length > 1 && /^photo[0-9]+$/.test(parts[1])) {// && typeof(this.photos_index[parts[1]]) !== 'undefined'){
			var nr = parts[1].replace(/^photo([0-9]+)$/, '$1');
			if (!this.isOpen && this.photo_idx != nr) {
				this.photo_idx = parseInt(nr);
			}
//			else if(this.isOpen){
//				var cont = this.getElement();
//				console.log(parseInt(nr));
//				$(cont).data('lightGallery').slide(parseInt(nr));
//			}
		}
		if (!this.isOpen) {
			this.init();
		}
	};

	this.close = function () {
		this.ignore(false);
		this.photos = new Array();
		this.album_data = null;
		this.album_id = '';
		this.dataUrl = '';
		this.photo_idx = '';
		this.isOpen = false;
		//this.hcb = null;
	};

	this.ignore = function () {
		this.hcb.lock = !!arguments[0];
	};
	this.isIgnored = function () {
		return !!this.hcb.lock;
	};
	this.getUrl = function () {
		var url = this.getElement().data('url');
		if (!url || url === '') {
			url = this.base_url + this.album_id;//location.pathname + '/albumdata/' + this.album_id;
		}
		return url;
	};
	//this.route();
}
;

function gallery_hash() {
	var wr = new galleryWrapper();
	wr.base_url = location.pathname + '/albumdata/';
	hc.register({
		callback: function (e, hcb) {
			wr.route(e, hcb);
		},
		rule: new RegExp("^\!album[0-9]+(/photo[0-9]+)*$")
	});
	$('.gallery_list, .search_results, .assoc_gallery_cont').on("click", ".gallery_popup", function () {
		location.hash = '!' + $(this).attr('id');
	});

}

function youtube_hash() {

	var wry = new galleryWrapper({
		loop: false,
		youtubePlayerParams: {
			//autoplay: 0,
			rel: 0/*,
			 showinfo: 0*/
		},
		counter: false,
		videoMaxWidth: '900px',
		addClass: "youtubegallery_popup",
		fullScreen: false
	});

	wry.base_url = location.pathname + '/itemdata/';

	wry.setPhotos = function (data) {
		var obj = {
			src: data.youtube_share_link,
			thumb: data.imgthumbnail//,
			//poster: data.imgposter // reikalingas jei norim autoplay=0
		};
		if (data.title) {
			obj.subHtml = '<div class="photo_title">' + data.title + '</div>';
		}
		wry.photos.push(obj);
	};

	wry.galleryEvents = function (cont) {
		$(cont).on('onCloseAfter.lg', function () {
			wry.hcb.hashObj.clear();
			wry.close();
		});
	};

	hc.register({
		callback: function (e, hcb) {
			wry.route(e, hcb);
		},
		rule: new RegExp("^\!yt[0-9]+$")
	});
	$('.youtube_list, .search_results, .assoc_gallery_cont').on("click", ".youtube_popup", function () {
		location.hash = '!' + $(this).attr('id');
	});
}

function getMoreNews(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.news_list').append(html);
		imagesLoaded($('.news_list'), function () {
			equalheight_list_items('.equalheight');
		});
		$('.loader_content').hide();
	});
}

function getMoreAlbums(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.gallery_list').append(html);
		imagesLoaded($('.gallery_list'), function () {
			equalheight_list_items('.equalheight');
		});
		$('.loader_content').hide();
	});
}

function getMoreVideos(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.youtube_list').append(html);
		imagesLoaded($('.youtube_list'), function () {
			equalheight_list_items('.equalheight');
		});
		$('.loader_content').hide();
	});
}


window.isMobile = {
	Android: function () {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function () {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function () {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function () {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function () {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function () {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	}
};


function fixed_header() {
	$('.container-fluid').click(function () {
		$(".langs_drop_cont").slideUp("fast");
		$(".langs_cont").removeClass("dropped");
	});

	$(".current_lang_cont").click(function (e) {
		e.stopPropagation();
		$(this).parent().toggleClass("dropped");
		$(this).parent().find(".langs_drop_cont").slideToggle("fast");
	});

	// Fixes the fixed header in iOS
	if (isMobile.iOS()) {
		var $body;
		if ('ontouchstart' in window) {
			$body = $("body");
			document.addEventListener('focusin', function () {
				return $body.addClass("fixfixed");
			});
			return document.addEventListener('focusout', function () {
				$body.removeClass("fixfixed");
				return setTimeout(function () {
					return $(window).scrollLeft(0);
				}, 20);
			});
		}
	}

}

function print_v() {
	$(".print_button").click(function () {
		window.print();
	});
}

function highlight_search_results() {
	if ($('#search_results_container').length > 0) {
		var query = $('#search_results_container').attr('data-text');
		if (typeof (query) !== 'undefined' && query !== '') {
			$('#search_results_container').highlight(query);
		}
	}

}

function init_questions_toggler_hash() {

	var $ct = $('.category-title');
	var $tt = $('.topic-title');
	var offset = ($('.fixed_header').is(':visible')) ? 50 : 0;

	var self = this;

	function getArgs() {
		var query = window.location.hash;
		query = query.substr(1)
		var args = new Array();
		query.split("/").forEach(function (part) {
			var item = part.split("-");
			args[item[0]] = item[1];
		});
		return args;
	}
	var args = getArgs();

	if (typeof args['c'] !== 'undefined') {
		setTimeout(function() {
			var categoryElement = $('[data-category-id="' + args['c'] + '"]');
			if (categoryElement.length > 0) {
				categoryElement.find('.category-title').attr('data-category-role', 'open').next('.topics').removeClass('hidden').addClass('visible');
				categoryElement.next('.topics').slideDown("fast");
				var offsetTop = categoryElement.offset();
				if (offsetTop) {
					$('html,body').animate({
						scrollTop: offsetTop.top - 10 - this.offset + 'px'
					}, 'fast');
				}
			}
		}, 500);
	}

	if (typeof args['t'] !== 'undefined') {
		setTimeout(function() {
			var topicElement = $('[data-topic-id="' + args['t'] + '"]');
			if (topicElement.length > 0) {
				topicElement.attr('data-topic-role', 'open').next('.topic-description').removeClass('hidden').addClass('visible');
				topicElement.next('.topic-description').slideDown("fast");
				var offsetTop = topicElement.offset();
				if (offsetTop) {
					$('html,body').animate({
						scrollTop: offsetTop.top - 10 - this.offset + 'px'
					}, 'fast');
				}
			}
		}, 500);
	}

	function hide(sel) {
		return sel.slideUp("fast").removeClass('visible').addClass('hidden');
	}

	function show(sel) {
		return sel.slideDown("fast").removeClass('hidden').addClass('visible');
	}

	function ctEvent() {
		$ct.click(function () {

			if ($(this).attr('data-category-role') === 'close') {
				var cur = $(this);

				hide($ct.attr('data-category-role', 'close').next('.topics')).not($(this));
				hide($tt.attr('data-topic-role', 'close').next('.topic-description'));
				show($(this).attr('data-category-role', 'open').next('.topics'));

				window.location.hash = '#c-' + $(this).attr('data-category-id');

			} else if ($(this).attr('data-category-role') === 'open') {

				hide($ct.attr('data-category-role', 'close').next('.topics'));
				hide($tt.attr('data-topic-role', 'close').next('.topic-description'));
				hide($(this).attr('data-category-role', 'close').next('.topics'));
				history.pushState("", document.title, window.location.pathname + window.location.search);

			}
		});
	}

	function ttEvent() {
		$tt.click(function () {
			if ($(this).attr('data-topic-role') === 'close') {
				var cur = $(this);
				hide($('.no-topics')).prev('.category-title').attr('data-category-role', 'close');

				hide($tt.parent('.topics:not(.show)').not($(this).parent()));
				$tt.parent().prev('.category-title').not($(this).parent().prev('.category-title')).attr('data-category-role', 'close');
				hide($tt.not($(this)).attr('data-topic-role', 'close').next('.topic-description').not($(this).next('.topic-description')));

				show($(this).attr('data-topic-role', 'open').next('.topic-description'));

				history.pushState("", document.title, window.location.pathname + window.location.search + '#c-' + $(this).attr('data-category-id') + '/' + 't-' + $(this).attr('data-topic-id'));

			} else if ($(this).attr('data-topic-role') === 'open') {

				hide($('.no-topics')).prev('.category-title').attr('data-category-role', 'close');

				hide($tt.parent('.topics:not(.show)').not($(this).parent()));
				$tt.parent().prev('.category-title').not($(this).parent().prev('.category-title')).attr('data-category-role', 'close');
				hide($tt.not($(this)).attr('data-topic-role', 'close').next('.topic-description').not($(this).next('.topic-description')));

				hide($(this).attr('data-topic-role', 'close').next('.topic-description'));

				window.location.hash = '#c-' + $(this).attr('data-category-id');
			}
		});
	}

	function initEvents() {
		ctEvent();
		ttEvent();
	}

	initEvents();

}

function catalog_gallery() {
	$(".catalog_gallery a").click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		$(".catalog_gallery a").removeClass("active_ph");
		$(this).addClass("active_ph");
		$("a.full_photo_preview").removeClass("current_photo");
		$(".main_photo a.photo" + $(this).data("href")).addClass("current_photo");
	});
}


function file_input() {
	var langAttribute = $('html').attr('lang') || 'en';

	var label;
	if (langAttribute === 'lt') {
		label = 'Įkelti';
	} else if (langAttribute === 'en') {
		label = 'Browse';
	} else {
		label = 'Įkelti';
	}

	$("input[type=file]").nicefileinput({
		label: label
	});
}

function mobile_overflow_tables() {
	if ($(".content_template").length) {
		$('.content_template table').each(function () {
			var element = $(this);
			// Create the wrapper element
			var scrollWrapper = $('<div />', {
				'class': 'scrollable',
				'html': '<div />' // The inner div is needed for styling
			}).insertBefore(element);
			// Store a reference to the wrapper element
			element.data('scrollWrapper', scrollWrapper);
			// Move the scrollable element inside the wrapper element
			element.appendTo(scrollWrapper.find('div'));
			// Check if the element is wider than its parent and thus needs to be scrollable
			if (element.outerWidth() > element.parent().outerWidth()) {
				element.data('scrollWrapper').addClass('has-scroll');
			}
			// When the viewport size is changed, check again if the element needs to be scrollable
			$(window).on('resize orientationchange', function () {
				if (element.outerWidth() > element.parent().outerWidth()) {
					element.data('scrollWrapper').addClass('has-scroll');
				} else {
					element.data('scrollWrapper').removeClass('has-scroll');
				}
			});
		});
	}
}

function iframe_adaptability() {

	var $container = $(".content_template");
	var $iframes = $("iframe");

	$container.find($iframes).each(function () {
		$(this).wrap("<div class='iframe_wrapper'></div>");
	});
}

function getMoreInstagramPhotos(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: true
	}).done(function (html) {
		$('.instagram_list').append(html);
		$('.loader_content').hide();
	});
}


function reportbug_form() {
	if ($("#reportbug_form_wrapper").length) {
		$(".reportbug_link a").fancybox({
			type: "inline",
			padding: [55, 10, 30, 20],
			margin: [10, 0, 10, 0],
			afterClose: function () {
				$("#reportbug_form_wrapper").removeClass('form-success');
				$(".bugreport_form").find(".bugreport_form_infos").hide();
				$(".bugreport_form").find(".one_item").show();
				$(".bugreport_form").find(".reportbug_submit").show();
				$(".bugreport_form").find(".phpcaptcha_container").show();
			}
		});

		$(".bugreport_form").validate({
			highlight: function (element, errorClass, validClass) {
				if ($(element).closest(".type_item").length) {
					$(element).closest(".type_item").removeClass(validClass).addClass(errorClass);
				}
			},
			unhighlight: function (element, errorClass, validClass) {
				if ($(element).closest(".type_item").length) {
					$(element).closest(".type_item").removeClass(errorClass).addClass(validClass);
				}
			},
			errorPlacement: function (error, element) {
				$(element).closest(".type_item").find('.type_error').append(error);
			},
			submitHandler: function (form) {
				if ($(".bugreport_form").hasClass("currently_sending")) { // if btn inactive
					return false;
				}
				var data = $(form).serialize();
				var base64image = $('.canvas-preview')[0].src;
				if (base64image != '') {
					data += '&image=' + base64image;
				}
				var url = $(form).data("url");
				var $form = $(".bugreport_form");
				$form.addClass("currently_sending");
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function (data) {
						$form.removeClass("currently_sending");
						var $infoc = $(".bugreport_form_infos");
						$infoc.find(".info_cont").fadeOut("fast").html();
						$infoc.find(".error_cont").fadeOut("fast");
						$infoc.find(".error_cont .errors_list").html();
						if ($(".phpcaptcha_container", $form).length) {
							var captchasrc = $form.find("#captcha_value_image").attr("src");
							$form.find("#captcha_value_image").attr("src", captchasrc.split("?")[0] + "?r=" + Math.random());
						}
						if (!data.data.success) {
							$infoc.fadeIn("fast");
							$infoc.find(".error_cont").fadeIn("fast").find(".errors_list").html('<p>' + data.data.errors.join("</p><p>") + '</p>');
							$(".fancybox-inner").animate({scrollTop: 0 + 'px'}, 'fast');

						} else {
							$("#reportbug_form_wrapper").addClass('form-success');
							$infoc.fadeIn("fast");
							$infoc.find(".info_cont").fadeIn("fast").html('<p>' + data.data.message + '</p>');
							$form.find("input").not("[name=" + secure_xsrf_name + "]").val('');
							$('.canvas-preview')[0].src = '';
							$form.find("textarea").val('');
							$form.find(".one_item").fadeOut("fast");
							$form.find(".reportbug_submit").fadeOut("fast");
							$form.find(".phpcaptcha_container").fadeOut("fast");
						}
					}
				});
				return false;
			}
		});
	}
}

function show_more() {
	$('.blocks_container').find('.show_more').click(function () {
		$(this).toggleClass('active');
		$(this).parent('.text_container').next('.block_more_info').slideToggle('fast').toggleClass('open');
	});

	$('.blocks_container').find('.show_less').click(function () {
		$(this).parents('.single_block').find('.show_more').removeClass('active');
		$(this).parent('.block_more_info').slideUp('fast').removeClass('open');
	});

	$('.videos_list').find('.show_video_desc').click(function () {
		$(this).toggleClass('active');
		$(this).next('.resource_video_desc').slideToggle('fast');
	});
}

function postformwidget_validate() {
	var $form = $("#postformwidget_form");
	if ($form.length) {
		$form.validate({
			submitHandler: function (form) {
				if ($form.hasClass("currently_sending")) {
					return false;
				}
				var data = $(form).serialize();
				var url = $(form).data("url");
				$form.addClass("currently_sending");
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function (data) {
						$form.removeClass("currently_sending");
						var $infoc = $(".postformwidget_infos");
						$infoc.find(".info_cont").fadeOut("fast").html();
						$infoc.find(".error_cont").fadeOut("fast");
						$infoc.find(".error_cont .errors_list").html();
						if (!data.data.success) {
							$infoc.fadeIn("fast");
							$infoc.find(".error_cont").fadeIn("fast").find(".errors_list").html('<p>' + data.data.errors.join("</p><p>") + '</p>');
						} else {
							$infoc.fadeIn("fast");
							$infoc.find(".info_cont").fadeIn("fast").html('<p>' + data.data.message + '</p>');
							$form.find("input").val('');
							$form.find("textarea").val('');
							$form.find(".input_holder").fadeOut("fast");
							$form.find(".contact_block_title").fadeOut("fast");
							$form.find(".recaptcha_cont").fadeOut("fast");
							$form.find(".button_holder").fadeOut("fast");
							setTimeout(function () {
								$(window).trigger('resize');
							}, 450);
						}
					}
				});
				return false;
			}
		});
	}
}

function init_contacts() {
	if ($(".contacts_struct_cont").length) {
		$('#search_by_field').change(function () {
			$('#search_by_label').text($("#search_by_field option[value='" + $(this).val() + "']").text());
		});
	}
}

// http://iamceege.github.io/tooltipster/
function tooltipster() {
	if ($(".tooltip").length) {
		$('.tooltip').tooltipster({
			delay: 15
		});
	}
}

function tooltipPlain() {
    if ($('.tooltip-plain').length) {
        $('.tooltip-plain').tooltipster({
            delay: 15,
            theme: 'tooltipster-plain',
            animation: 'fade',
            trigger: 'hover',
            side: 'top',
            contentAsHTML: false,
            maxWidth: 200
        });
    }
}

function sidebar_menu() {
	if ($(".submenu_block").length > 0) {
		var $parent = $(".submenu_block");
		var $icons = $parent.find('.icon-chevron-down');

		if ($icons.length > 0) {
			$icons.each(function () {
				var sliding = false;

				$(this).click(function (e) {
					e.preventDefault();

					if (!sliding) {
						sliding = true;

						if (!$(this).parents('li').hasClass('show')) {
							$(this).parents('ul').children('li.show').removeClass('show').children('ul').slideUp(150);
							$(this).parents('ul').children('li').removeClass('prev next');
						}

						$(this).parents('li').toggleClass('show').removeClass('prev next');
						$(this).parents('li').prev().toggleClass('prev');
						$(this).parents('li').next().toggleClass('next');
						$(this).parent().next().slideToggle(150, function () {
							sliding = false;
						});
					}
				});
			});
		}
	}
}

function scroll_top() {
	if ($('.scroll_top').length > 0) {
		$('.scroll_top button').click(function () {
			$('html, body').animate({
				scrollTop: 0
			}, 300);
		});
	}
}

// titlepage calendar
var calendar_data = {
	baseurl: '',
	month: ''
};

function set_widgetcalendar_data() {
	calendar_data.baseurl = $('#widget_calendar').data('baseurl');
	calendar_data.month = $('#widget_calendar').data('month');
}

function getCalendarMonth(month) {
	loadMonth(month);
}

function loadMonth(month) {
	calendar_data.month = month;
	loadCalendar();
}

function loadCalendar() {
	$.ajax({
		url: calendar_data.baseurl + '/' + calendar_data.month,
		cache: false
	}).done(function (html) {
		$('#events_calendar').html(html);
		showDayEvent();
		showCurrentMonthEvents();
	});
}

function showDayEvent() {
	var activeDay = $('#widget_calendar .calendar_container .day.active');
	var $calendar_cont = $('.events_calendar_block');

	if ($("#widget_calendar .calendar_container").length > 0) {
		activeDay.each(function () {
			var $day = $(this);
			$day.on("click", function (e) {
				e.stopPropagation();
				activeDay.removeClass('selected');
				$day.addClass('selected');
				$calendar_cont.find('.firstload').hide();
				$calendar_cont.find('.day_events').hide();
				$calendar_cont.find('.day_events[data-selected-day="' + $day.data('day') + '"]').show();
			});
		});
	}
}

function showCurrentMonthEvents() {
	var days = document.querySelectorAll('.items_list .day_events');
	var i = 0;
	var event_list = [];

	for (i; i < days.length; i++) {
		var dataid = days[i].getAttribute('data-id');
		var includes = event_list.includes(dataid);

		if (null !== dataid && !includes) {
			days[i].classList.add('show');
			event_list.push(dataid);
		}
	}

	if (event_list.length < 1) {
		showNoEventMessage();
	}
}

function showNoEventMessage() {
	var container = document.querySelector('.section_events .items_list');
	if (null !== container) {
		var element = document.createElement('span');
		element.innerHTML = no_events;
		element.classList.add('no_tasks');
		container.appendChild(element);
	}
}

function EventCalendar(params) {
	var self = this;
	var calendar = {
		calendar_query: {
			category_id: 0,
			location_id: 0,
			month: '', //$("#content_calendar").attr('data-month')
			innerpage: 1,
			year: 0,
		},
		calendar_data: {
			baseurl: '',
			month: '',
			day: ''
		}
	};

	calendar.init = function () {
		calendar.set_widgetcalendar_data();
		calendar.calendarFilters();
//		calendar.calendarPaginate();
		calendar.showDayEventInner();
		calendar.changeMonth();
	};


	calendar.set_widgetcalendar_data = function () {
		calendar.calendar_data.baseurl = $('#widget_calendar').data('baseurl');
		calendar.calendar_data.month = $('#widget_calendar').data('month');
	};

	calendar.changeMonth = function () {
		$('.eventscalendar_list .prev_month, .eventscalendar_list .next_month').click(function () {
			calendar.getCalendarMonthInner($(this).attr('data-id'));
		});
	};

	calendar.getCalendarMonthInner = function (month) {
		calendar.calendar_query.month = month;
		calendar.loadMonthInner();
	};

	calendar.loadMonthInner = function () {
		calendar.loadCalendarInner();
	};

	calendar.calendarFilters = function () {
		$(".filters .categories").change(function () {
			calendar.calendar_query.category_id = $(this).val();
			calendar.loadMonthInner();
		});

		$(".filters .locations").change(function () {
			calendar.calendar_query.location_id = $(this).val();
			calendar.loadMonthInner();
		});

		$(".filters .years").change(function () {
			calendar.calendar_query.year = $(this).val();
			calendar.getCalendarMonthInner($(this).val());
		});

		$(".filters .limit").change(function () {
			$(".filters .limit .item").removeClass('active');
			$(this).addClass('active');
			calendar.calendarPaginate($(this).val());
		});
	};

	calendar.clearCalendarFilters = function () {
		calendar.calendar_query.location_id = 0;
		calendar.calendar_query.year = 0;
		calendar.calendar_query.month = '';
		calendar.calendar_query.category_id = 0;
		calendar.loadMonthInner();
	}

	calendar.initClearCalendarFiltersBtn = function () {
		var btns = document.querySelectorAll('.filters .clear_filter');
		if (null === btn) {
			return;
		}

		for (var i = 0; i < btns.length; i++) {
			var btn = btns[i];
			btn.addEventListener('click', calendar.clearCalendarFilters);
		}
	};

	calendar.loadCalendarInner = function (month) {
		var $calendar_cont = $('#content_calendar');
		var url = $calendar_cont.data('baseurl');
		var url_month = calendar.calendar_query.month;
		if (url_month == '') {
			url_month = $("#content_calendar").attr('data-month');
		}
		var ajaxUrl = url + '/' + url_month;//calendar.calendar_query.month
		$.ajax({
			url: ajaxUrl,
			cache: false,
			data: calendar.calendar_query
		}).done(function (html) {
			$calendar_cont.html(html).promise().done(function (arg1) {
				$('.eql_event').responsiveEqualHeightGrid();
				select2init();
				toggle_items();
			});
			calendar.showDayEventInner();
			calendar.changeMonth();
			calendar.initClearCalendarFiltersBtn();
		});
	};

	calendar.showDayEventInner = function (fromAjax) {
		var $calendar_cont = $('#content_calendar');
		var loader = $('#content_calendar').find('.loader_item');
		loader.hide();

		if ($calendar_cont.length > 0 && $("#events_calendar").length > 0) {
			$('.day_withevents.active .day_number').each(function () {
				$(this).on("click", function (e) {
					e.stopPropagation();
					var $tm;
					var $day = $(this);
					clearTimeout($tm);
					$('.day_withevents.active').removeClass('selected');
					$(this).parent().addClass('selected');
					$calendar_cont.find('.day_events:not(.calendar_item):not(.loader_item):not(.empty_item)').hide();
					$('.pagination-container').hide();
					loader.show();
					calendar.calendar_data.day = $day.data('day');
					$tm = setTimeout(function () {
						loader.hide();
						$calendar_cont.find('.day_events[data-selected-day="' + $day.data('day') + '"]').show();
						calendar.calendarPaginate();
					}, 300);

				});
			});

			if ($('.day_withevents.active.current').length > 0) {
				$('.day_withevents.active.current .day_number').trigger('click').addClass('open');
			} else if ($('.day_withevents.active').length > 0) {
				$($('.day_withevents.active .day_number')[0]).trigger('click').addClass('open');
			}

			calendar.calendarFilters();
		}

	};

	calendar.calendarPaginate = function (perpage) {
		if ($('.eventscalendar_list .list').length > 0 && calendar.calendar_data.day) {

			$(".eventscalendar_list .pagination-container").remove();

			if (typeof (perpage) === 'undefined') {
				var perpage = $("#content_calendar").attr('data-perpage');
			}
			$('.eventscalendar_list .list .day_events[data-selected-day="' + calendar.calendar_data.day + '"]').paginathing({
				perPage: perpage,
				firstLast: false,
				prevText: "&lsaquo;",
				nextText: '&rsaquo;'
			});
		}
	};

	calendar.init();
}

function loadTitlepageCalendar() {
	if ($('.tp_widget_calendar').length > 0 && typeof $('.tp_widget_calendar').data('month') !== 'undefined' && $('.tp_widget_calendar').data('month') !== '') {
		getCalendarMonth($('.tp_widget_calendar').data('month'));
	}
}

function toggle_items() {
	$('.btn_toggle').click(function () {
		$(this).parent().parent().find('.toggle_content').toggleClass('active');
		$(this).toggleClass('rotate');
	});
}

function addAriaLabelToMobileMenu() {
	var elementsList = document.querySelectorAll('a.mm-next');

	if (elementsList.length < 1) {
		return;
	}

	for (var i = 0; i < elementsList.length; i++) {
		var element = elementsList[i];
		element.setAttribute('aria-label', globalJsTranslations().getTr('next'));
	}
}

// Chartjs
var htmlLegendPlugin = {
	id: 'htmlLegend',
	afterUpdate: function (chart, args, options) {
		var legendContainer = document.getElementById(options.containerID);

		// Remove old legend labels
		while (legendContainer.firstChild) {
			legendContainer.firstChild.remove();
		}

		// Reuse the built-in legendItems generator
		var labels = chart.options.plugins.legend.labels.generateLabels(chart);

		labels.forEach(function (label) {
			var div = document.createElement('div');
			div.classList.add('chart-legend__item');

			// Color box
			var colorBox = document.createElement('span');
			colorBox.classList.add('icon');
			colorBox.style.background = label.fillStyle;
			div.appendChild(colorBox);

			// Text box
			var textBox = document.createElement('span');
			textBox.classList.add('text');
			textBox.classList.add('text1320');
			textBox.textContent = label.text;
			div.appendChild(textBox);

			if (chart.config.type == 'pie' || chart.config.type == 'doughnut') {
				// Value box
				var valueBox = document.createElement('span');
				valueBox.classList.add('value');
				valueBox.classList.add('text1320');
				valueBox.textContent = chart.data.datasets[0].data[label.index];
				div.appendChild(valueBox);
			}

			legendContainer.appendChild(div);
		});
	}
};

var customChartJsTooltip = {
	enabled: false,

	external: function (context) {
		// Tooltip Element
		var tooltipEl = document.getElementById('chartjs-tooltip');

		// Create element on first render
		if (!tooltipEl) {
			tooltipEl = document.createElement('div');
			tooltipEl.id = 'chartjs-tooltip';
			tooltipEl.classList.add('chartjs-tooltip');
			document.body.appendChild(tooltipEl);
		}

		// Hide if no tooltip
		var tooltipModel = context.tooltip;
		if (tooltipModel.opacity === 0) {
			tooltipEl.style.opacity = 0;
			return;
		}

		// Set caret Position
		tooltipEl.classList.remove('above', 'below', 'no-transform');
		if (tooltipModel.yAlign) {
			tooltipEl.classList.add(tooltipModel.yAlign);
		} else {
			tooltipEl.classList.add('no-transform');
		}

		function getDataValue(item) {
			return item.formattedValue;
		}

//		Set Text
		if (tooltipModel.dataPoints) {
			var titleLines = tooltipModel.title || [];
			var bodyLines = tooltipModel.dataPoints.map(getDataValue);
			var innerHtml = '';

			// Head content
			if (titleLines.length > 0) {
				innerHtml += '<div class="chartjs-tooltip__h">';
				titleLines.forEach(function (title) {
					innerHtml += '<div class="chartjs-tooltip__h-item">' + title + '</div>';
				});
				innerHtml += '</div>';
			}
			// Head content END

			// Body content
			innerHtml += '<div class="chartjs-tooltip__b">';
			bodyLines.forEach(function (body, i) {
				var colors = tooltipModel.labelColors[i];
				var style = 'background:' + colors.backgroundColor;
				var span = '<span class="color" style="' + style + '"></span>';
				innerHtml += '<div class="chartjs-tooltip__b-item">' + span + body + '</div>';
			});
			innerHtml += '</div>';
			// Body content END

			tooltipEl.innerHTML = innerHtml;
		}
//
		var position = context.chart.canvas.getBoundingClientRect();

		// Display, position, and set styles for font
		tooltipEl.style.opacity = 1;
		tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.x + 'px';
		tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.y + 'px';
//		tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
//		tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
	}
};

function doScreenshot() {
	$('body').addClass('loading-page');
	html2canvas(document.body, {}).then(function (canvas) {
		$('body').removeClass('screenshot-mode');
		$('#bbox').hide();
		$('.canvas-preview')[0].src = canvas.toDataURL("image/png");

		$('#screenshot-preview-holder').fancybox({
			afterClose: function () {
				$("#screenshot-preview-holder").show();
			}
		});
		$('body').removeClass('loading-page');
	});
}

function markSpot() {
	$('body').addClass('screenshot-mode');

	var x, y, oldx, oldy;
	var showDrag = false;

	$(document).on("mousedown", "body.screenshot-mode", function (e) {
		oldx = e.clientX;
		oldy = e.clientY;
		showDrag = true;
		e.preventDefault();
	});
	$(document).on("mousemove", "body.screenshot-mode", function (e) {
		if (showDrag == true) {
			x = e.clientX;
			y = e.clientY;
			var bbox = $("#bbox")[0];
			var contbox = $("body.screenshot-mode")[0];
			var w = (x > oldx ? x - oldx : oldx - x);
			var h = (y > oldy ? y - oldy : oldy - y);
			var addx = 0, addy = 0;
			if (x < oldx) {
				addx = w;
			}
			if (y < oldy) {
				addy = h;
			}
			bbox.style.left = (oldx - parseInt((contbox.offsetLeft + addx))) + "px";
			bbox.style.top = (oldy + parseInt((window.pageYOffset + addy))) + "px";
			bbox.style.width = w + "px";
			bbox.style.height = h + "px";
			bbox.style.display = "block";
		}
		e.preventDefault();
	});
	$(document).on("mouseup", "body.screenshot-mode", function (e) {
		showDrag = false;
		e.preventDefault();
		doScreenshot();
	});
}

function user_control() {
	var user_control_container = document.querySelector('.user_control');
	if (user_control_container !== null) {
		$(".icon-user-profile").click(function (e) {
			e.stopPropagation();
			$(this).parent().find(".user_control__links").slideToggle("fast");
		});

		if ($('.user_control__links:visible')) {
			$('body').click(function () {
				$(this).parent().find(".user_control__links").slideUp("fast");
			});
		}
	}
}

$(document).ready(function() {
	$('.read-more span.highlight').removeClass('highlight').addClass('green');
	$('.cv.fancybox_ajax').fancybox({
		type: 'html',
		beforeLoad: function(instance, current) {
			var content = $(current.opts.$orig).data('text');
			current.src = '<div class="custom-fancybox-content">' + content + '</div>';
		}
	});

	$('.tasks.fancybox_ajax').fancybox({
		type: 'html',
		beforeLoad: function(instance, current) {
			var content = instance.group[0].src;
			current.src = '<div class="custom-fancybox-content">' + content + '</div>';
		}
	});

	$('.toggle-description').on('click', function() {
		var $wrapper = $(this).closest('.wrapper');
		var remainingText = $wrapper.find('.remaining-text');
		var chevronIcon = $(this).find('.icon');
		var showMoreText = $(this).data('show-more');
		var showLessText = $(this).data('show-less');

		if (remainingText.is(':visible')) {
			remainingText.slideUp(400);
			$(this).contents().first().replaceWith(showMoreText + ' ')
			chevronIcon.css('transform', 'rotate(90deg)');
		} else {
			remainingText.slideDown(400);
			$(this).contents().first().replaceWith(showLessText + ' ');
			chevronIcon.css('transform', 'rotate(-90deg)');
		}
	});

	$('.services-wrapper .service').slice(0, 12).show();

	$('.services_more').click(function(e) {
		e.preventDefault();

		const $this = $(this);
		const hiddenItems = $this.prev('.services-wrapper').find('.service').slice(12);
		const showMoreText = $this.data('show-more');
		const showLessText = $this.data('show-less');
		const chevronIcon = $this.find('.icon');

		chevronIcon.css({
			'transition': 'transform 0.3s ease',
			'-webkit-transition': 'transform 0.3s ease'
		});

		hiddenItems.slideToggle(300, function() {
			if (hiddenItems.is(':visible')) {
				$this.contents().first().replaceWith(showLessText + ' ');
				chevronIcon.css('transform', 'rotate(180deg)');
			} else {
				$this.contents().first().replaceWith(showMoreText + ' ');
				chevronIcon.css('transform', 'rotate(0deg)');
			}
		});
	});

	$('.toggle-contacts').on('click', function() {
		$(this).next('.child-contacts').slideToggle();
		$(this).toggleClass('open');
		$(this).find('.icon').toggleClass('icon-down icon-up');
	});

	$('a[data-title]').hover(
		function () {
			const tooltipText = $(this).attr('data-title');

			const tooltip = $('<div class="menu-tooltip"></div>');
			tooltip.text(tooltipText);

			const parentLi = $(this).closest('li');
			parentLi.append(tooltip);

			tooltip.css({
				top: 0,
				left: '100%',
				width: 'auto',
				minWidth: 'max-content',
			});

			setTimeout(() => {
				tooltip.css({
					transform: 'translateX(0)',
					opacity: 1,
				});
			}, 10);
		},
		function () {
			const tooltip = $(this).closest('li').find('.menu-tooltip');

			tooltip.css({
				transform: 'translateX(-10px)',
				opacity: 0,
			});

			setTimeout(() => {
				tooltip.remove();
			}, 300);
		}
	);


});


